import { render, staticRenderFns } from "./BinHeader.vue?vue&type=template&id=16b409fb&scoped=true&"
import script from "./BinHeader.vue?vue&type=script&lang=js&"
export * from "./BinHeader.vue?vue&type=script&lang=js&"
import style0 from "./BinHeader.vue?vue&type=style&index=0&id=16b409fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b409fb",
  null
  
)

export default component.exports